<template>
  <v-layout row wrap>
    <v-flex class="pt-0 pb-3 px-3">
      <v-card class="elevation-0">
      
        <v-container fluid grid-list-md>

          <v-layout row wrap>
            <template v-for="(card, i) in cards">
              <v-flex xs6 sm4 md3 lg2
                class="pa-3"
                :key="i"
                v-if="card.component_path['card_viewable']==undefined?true:card.component_path.card_viewable"           
              >
                <v-card class="elevation-0" @click="btn_onClick(card)" style="cursor:pointer;">
                  <v-img
                    :src="card.img_url"
                    width="120px"
                    style="margin:auto;"
                  ></v-img>
                  <v-card-title primary-title class="justify-center pt-1 pb-1">
                    <center><div class="text-md-center">{{ card.display_text }}</div></center>
                  </v-card-title>
                </v-card>
              </v-flex>
            </template>
          </v-layout>

        </v-container>
      </v-card>

      <!-- START dialog -->
      <v-dialog v-model="dialog.visible" persistent scrollable max-width="1000px">
        <v-card>
          <v-card-text>
            <v-container fluid class="pa-3">
              <v-layout row wrap>
                <v-flex xs12>
                  <iframe
                    frameborder="0"
                    :src="dialog.iframe_url"
                    width="100%"
                    height="1000px"
                  ></iframe>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange" flat @click="dialog.visible = false; dialog.iframe_url=''">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-flex>
  </v-layout>
</template>

<script>
import auth from "../../functions/auth";
import common from "../../functions/general";

export default {
  name: "CardListingPub",
  // components: {
  //   Breadcrumbs: Breadcrumbs
  // },
  data: () => ({
    username: "",
    cards: [],
    dialog: {
      visible: false,
      iframe_url: "",
    }
  }),
  mounted: async function() {
    // this.initial();
    this.username = auth.getUsername();   
    // var pageID = common.App.get_pageID();
    // this.cards = common.App.getAppMenu(pageID);
    var pageUUID = common.App.get_pageUUID();
    var rec_order_desc = common.App.get_searchParams("orderDesc");
    this.cards = common.App.getAppMenu(pageUUID, rec_order_desc);
  },
  methods: {
    btn_onClick(data) {
      var method = data.method__class_name + "-" + data.method__column_name + "-" + data.method__key;

      switch(method) {
        case "Page-method-1":
          window.open(data.path);
          break;
          
        case "Page-method-3":
          this.dialog.visible = true;
          this.dialog.iframe_url = data.component_path.iframe_path;
          break;

        default:
          // this.router_props = {
          //   // form_id: card.component_path.form_id,
          //   form_name: data.component_path.form_name,
          //   addNew_path: data.component_path.addNew_path,
          //   display_text: data.display_text,
          //   return_page: data.path  
          // };

          // var router = {
          //   pageid: data.id
          // };
          // this.$router.push({ path: data.path, query: router });
          window.location.href = data.path + "?uuid=" + data.uuid + "&orderDesc=" + data.component_path.orderDesc;

          // this.initial();
          //window.location.reload();
      }
    // },
    // onClick_breadcrumb(e){
    //   this.btn_onClick(e);
    }
  }
};
</script>

<style>
</style>
